import { MetricGroup } from './MetricGroup';
import { MetricSharedLinkContact } from './MetricSharedLinkWrapper';
import { LocalDate } from '../../../core/pojo/date-variable';
import { MetricData, MetricDataRole } from './MetricData';
import { MetricCalculationService } from "../service/internal/metric-calculation.service";

export class MetricGroupsAndPeriods {
  metricGroups: MetricGroup[] = [];
  periods: MetricPeriodWrapper = {
    actual: [],
    budget: [],
  };

  static deserializeMetricGroupsAndPeriods(object: MetricGroupsAndPeriods): MetricGroupsAndPeriods {
    const instance = Object.assign(new MetricGroupsAndPeriods(), object);
    instance.metricGroups = instance.metricGroups.map(MetricGroup.deserializeMetricGroup);
    MetricCalculationService.setSignsForGroups(instance.metricGroups);
    MetricCalculationService.setGroupsVisibility(instance.metricGroups);
    return instance;
  }

  removeBudgetMetricData(): void {
    this.metricGroups.forEach((group) => {
      group.metrics.forEach((metric) => {
        metric.companyMetrics[0].metricData = metric.companyMetrics[0].metricData.filter((data) => data.role !== MetricDataRole.BUDGET);
      });
    });
  }

  removeActualMetricData(): void {
    this.metricGroups.forEach((group) => {
      group.metrics.forEach((metric) => {
        metric.companyMetrics[0].metricData = metric.companyMetrics[0].metricData.filter((data) => data.role !== MetricDataRole.ACTUAL);
      });
    });
  }

  isAtLeastOneGroupSelected(): boolean {
    return this.metricGroups.some((group) => group.temp.isSomeMetricsSelected);
  }
}

export class MetricsForExternalUsers extends MetricGroupsAndPeriods {
  contact: MetricSharedLinkContact;
}

export interface MetricUploadByExternalUser {
  request: MetricUploadPasswordWrapper;
  metricData: MetricData[];
  userData: MetricUploadUserData;
}
export interface MetricUploadUserData {
  name: string,
  email: string,
}

export interface MetricUploadPasswordWrapper {
  password: string;
  token: string;
  captchaV2Token?: string;
  captchaV3Token?: string;
}

export interface MetricPeriodWrapper {
  actual: MetricPeriod[];
  budget: MetricPeriod[];
}

export interface MetricPeriod {
  period: LocalDate;
  isRequested: boolean;
}

export class DefaultMetricChartsNamesDTO {
  arr: DefaultMetricChartArrDTO;
  client: DefaultMetricChartClientDTO;
  pnl: DefaultPnlMetricChartDTO;
  headCount: DefaultHeadCountMetricChartDTO;
}
export class BaseMetricChartDTO {
  groupName: string;
}

export class DefaultMetricChartArrDTO extends BaseMetricChartDTO {
  starting: string;
  ending: string;
  metricNew: string;
  upSell: string;
  churn: string;
  downSell: string;
}

export class DefaultMetricChartClientDTO extends BaseMetricChartDTO {
  starting: string;
  ending: string;
  metricNew: string;
  cancelled: string;
}

export class DefaultPnlMetricChartDTO extends BaseMetricChartDTO {
  sales: string;
  marketing: string;
  customerSuccess: string;
  rnd: string;
  gna: string;
  cogs: string;
}

export class DefaultHeadCountMetricChartDTO extends BaseMetricChartDTO {
  sales: string;
  marketing: string;
  customerSuccess: string;
  rnd: string;
  gna: string;
  cogs: string;
}
